const Card = ({ children }) => (
    <div className="card bg-white p-10 rounded-lg shadow-lg max-w-lg w-3/4 lg:max-w-xl mx-auto mt-20 mb-20">
      {children}
    </div>
  );
  
  export default Card;
  